import type { SortOrderType } from 'models';

export const mapSortOrderRails = (sort?: SortOrderType) =>
  sort
    ? (
        {
          ascend: 'asc',
          descend: 'desc',
        } as const
      )[sort]
    : undefined;

export const getRailsSortParameters = <T extends string>(data: Record<T, SortOrderType | undefined>) => {
  for (const [key, value] of Object.entries(data)) {
    if (value) {
      return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        order: key as T,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        sort: mapSortOrderRails(value as SortOrderType),
      };
    }
  }

  return {};
};
